import { UserManagementTab } from "@/components/admin/UserManagementTab";
import AdminHeader from "@/components/admin/AdminHeader";

/**
 * Admin component that provides an interface for managing users.
 * It includes a user management tab that allows administrators to
 * view and manage pending and existing user accounts.
 */
function Admin() {
  return (
    <div className="flex flex-col h-screen">
      <AdminHeader />
      <main className="flex-1 overflow-y-auto p-4 lg:p-6">
        <UserManagementTab />
      </main>
    </div>
  );
}

export default Admin; 